import {fromJS} from 'immutable'

export const offeringState = fromJS({
  id: 0,
  subjects: [],
  section: '',
  instructor_id: 0,
  instructor_id_input: '',
  instructor_name: '',
  max_slots: '',
  schedule: '',
  is_offsem: false,
})

const initialState = fromJS({
  item: {}, // item: { 1: {"subject": "Math"}}
  searchResults: [],
  pending: false,
})

export default function offering(state = initialState, action) {
  switch (action.type) {
    case 'OFFER_REQ':
    case 'OFFER_Q_REQ':
      return state.set('pending', true)

    case 'OFFER_Q_SUCC':
      return state
        .set('pending', false)
        .set('searchResults', fromJS(action.payload))

    case 'OFFER_GET_SUCC':
    case 'OFFER_SAVE_SUCC':
      return state
        .set('pending', false)
        .setIn(['item', action.payload.id], fromJS(action.payload))

    case 'OFFER_DEL_SUCC':
      return state
        .set('pending', false)
        .removeIn(['item', Number(action.payload)])

    case 'NOTIF_FAIL':
      return state.set('pending', false)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/Setup/Offerings/reducer.js